import React from "react";
import { I18nRichText } from "./inputs/I18nRichText";

declare const I18n;

type Props = {
  onSelect: (userType: "learner" | "facilitator") => void;
};

const SelectUserType: React.FC<Props> = ({ onSelect }) => {
  const options: { type: "learner" | "facilitator"; label: string }[] = [
    { type: "learner", label: I18n.t("views.onboarding.select_user_type.i_am_a_learner") },
    { type: "facilitator", label: I18n.t("views.onboarding.select_user_type.i_am_a_facilitator") },
  ];

  const chooseUserMessage = I18n.t("views.onboarding.select_user_type.choose_role");
  const robotSvg = require('images/003-robot-2.svg') as string;
  const sciFiSvg = require('images/008-science-fiction.svg') as string;

  const renderIcon = (type: "learner" | "facilitator") => {
    const src = type === "learner" ? robotSvg : sciFiSvg;
    return (
      <img
        src={src}
        alt=""
        aria-hidden="true"
        style={{ display: "block" }}
      />
    );
  };

  return (
    <div>
      <p style={{ maxWidth: "70ch", margin: "0 auto 2.5rem"}}>
        <I18nRichText tKey="views.onboarding.select_user_type.intro_paragraph" />
      </p>
      <h2 style={{ marginBottom: "1.5rem"}}>{chooseUserMessage}</h2>
      <div style={{ display: "flex", justifyContent: "center", gap: "2rem" }}>
        {options.map((opt) => (
          <button
            key={opt.type}
            type="button"
            onClick={() => onSelect(opt.type)}
            aria-label={opt.label}
            className="button-input"
          >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "0.5rem" }}>
              {renderIcon(opt.type)}
              <span>{opt.label}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SelectUserType;
